import { Button } from '@/ui'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { useState } from 'react'

export interface SaveToGalleryResult {
	name: string
	setAsDefaultFeed: boolean
	setAsDefaultStory: boolean
}

export interface SaveDialogProps {
	open: boolean
	onClose: () => void
	onSave: (result: SaveToGalleryResult) => void
	saving?: boolean
}

export function SaveDialog({ open, onClose, onSave, saving }: SaveDialogProps) {
	const [name, setName] = useState('')
	const [setAsDefaultFeed, setSetAsDefaultFeed] = useState(false)
	const [setAsDefaultStory, setSetAsDefaultStory] = useState(false)

	const handleSave = () => {
		if (!name.trim()) { return }
		onSave({ name: name.trim(), setAsDefaultFeed, setAsDefaultStory })
	}

	return (
		<Dialog open={open} onClose={onClose} className="relative z-50">
			<DialogBackdrop className="fixed inset-0 bg-black/20 backdrop-blur-sm" />
			<div className="fixed inset-0 flex items-center justify-center">
				<DialogPanel className="bg-white rounded-lg shadow-xl p-6 w-[400px] space-y-4">
					<DialogTitle className="text-base font-semibold text-grey-800">
						Save to Gallery
					</DialogTitle>

					<div className="space-y-3">
						<label className="block">
							<span className="text-xs font-medium text-grey-600">Design name</span>
							<input
								type="text"
								className="mt-1 w-full rounded border border-grey-200 px-3 py-2 text-sm outline-none focus:border-brand-400 focus:ring-1 focus:ring-brand-400"
								value={name}
								onChange={(e) => setName(e.target.value)}
								placeholder="My Design"
								autoFocus={true}
								onKeyDown={(e) => {
									if (e.key === 'Enter') { handleSave() }
								}}
							/>
						</label>

						<div className="space-y-2">
							<label className="flex items-center gap-2 text-sm text-grey-700">
								<input
									type="checkbox"
									checked={setAsDefaultFeed}
									onChange={(e) => setSetAsDefaultFeed(e.target.checked)}
									className="rounded border-grey-300"
								/>
								Set as default feed ad design
							</label>
							<label className="flex items-center gap-2 text-sm text-grey-700">
								<input
									type="checkbox"
									checked={setAsDefaultStory}
									onChange={(e) => setSetAsDefaultStory(e.target.checked)}
									className="rounded border-grey-300"
								/>
								Set as default story ad design
							</label>
						</div>
					</div>

					<div className="flex justify-end gap-2 pt-2">
						<Button type="subtle" size="short" onClick={onClose}>
							Cancel
						</Button>
						<Button type="committal" size="short" onClick={handleSave} disabled={!name.trim() || saving}>
							{saving ? 'Saving...' : 'Save'}
						</Button>
					</div>
				</DialogPanel>
			</div>
		</Dialog>
	)
}
